import { useRouterState } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { setSiteFlash, SITE_FLASH_TEXT, useSiteFlash } from './flash';

/**
 * 根版面內容最上方的一句提示（見 flash.ts 的 `setSiteFlash`）。
 * 關掉、或換到另一個路徑（不含同頁的 search 變化）就清掉。
 */
export function SiteFlash() {
  const flash = useSiteFlash();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const shownOn = useRef<string | null>(null);

  useEffect(() => {
    if (flash === null) {
      shownOn.current = null;
      return;
    }
    if (shownOn.current === null) shownOn.current = pathname;
    else if (shownOn.current !== pathname) setSiteFlash(null);
  }, [flash, pathname]);

  if (flash === null) return null;
  return (
    <div
      role="status"
      className="mb-3 flex items-start justify-between gap-3 rounded-control border border-accent/40 bg-accent/10 px-3 py-2 text-13 leading-relaxed text-fg-1"
    >
      <span>{SITE_FLASH_TEXT[flash]}</span>
      <button
        type="button"
        onClick={() => {
          setSiteFlash(null);
        }}
        aria-label="關閉提示"
        className="shrink-0 rounded-full px-1.5 text-fg-2 hover:bg-surface-2 hover:text-fg-1"
      >
        ×
      </button>
    </div>
  );
}
